import { FormHelperText } from "@mui/material";
import React from "react";
import {
  ERROR_HELPERTEXT_STYLES,
  PRIMARY_COLOR,
  WARNING_COLOR,
} from "../utils";
import { ConfigProvider, Select } from "antd";

const Dropdown = ({
  label,
  options,
  value,
  helperText = "",
  error_state,
  error_text,
  name,
  allowClear,
  disabled,
  width,
  handleChange,
  size,
  required = false,
}) => {
  return (
    <div
      className={`select ${error_state && "error_select"}`}
      style={{ alignItems: helperText ? "flex-start" : "center" }}
    >
      <label
        htmlFor={name}
        style={{
          marginTop: helperText && "0.75rem",
          width: width && "55%",
          marginBottom: error_state && "1.3rem",
          fontSize: size === "middle" ? ".8rem" : "",
        }}
      >
        {label} {required ? <span>*</span> : ""}
      </label>
      <div>
        <ConfigProvider
          theme={{
            token: {
              colorPrimary: PRIMARY_COLOR,
              colorPrimaryHover: PRIMARY_COLOR,
              colorErrorOutline: "none",
              colorError: WARNING_COLOR,
              colorErrorBorderHover: "none",
              controlOutline: "none",
              fontSize: 12,
            },
          }}
        >
          <Select
            id={name}
            onChange={handleChange}
            options={options}
            style={{ width: "100%", textAlign: "left" }}
            showSearch
            value={value}
            size={size ? size : "large"}
            placeholder={"Select"}
            status={error_state && "error"}
            disabled={disabled}
          ></Select>
        </ConfigProvider>
        {error_state && (
          <FormHelperText sx={ERROR_HELPERTEXT_STYLES}>
            {error_text}
          </FormHelperText>
        )}
        <FormHelperText
          sx={{
            fontStyle: "italic",
            fontSize: "0.75rem",
            color: "#a0aec0",
            margin: "8px 0",
            lineHeight: "1rem",
            letterSpacing: "0.7px",
            fontFamily: "Montserrat",
          }}
        >
          {helperText}
        </FormHelperText>
      </div>
    </div>
  );
};

export default Dropdown;
